import { BuildingType } from "../types/buildings.js";
export const BUILDING_DEFINITIONS = {
    [BuildingType.TOWN_HALL]: {
        type: BuildingType.TOWN_HALL,
        name: "Town Hall",
        description: "The administrative center of your city. Increases maximum population.",
        maxLevel: 25,
    },
    [BuildingType.ACADEMY]: {
        type: BuildingType.ACADEMY,
        name: "Academy",
        description: "Scientists research new technologies here. Assign citizens as scientists.",
        maxLevel: 20,
        prerequisite: { building: { type: BuildingType.TOWN_HALL, level: 3 } },
    },
    [BuildingType.BARRACKS]: {
        type: BuildingType.BARRACKS,
        name: "Barracks",
        description: "Train land military units to defend your city or attack enemies.",
        maxLevel: 20,
        prerequisite: { building: { type: BuildingType.TOWN_HALL, level: 4 } },
    },
    [BuildingType.SHIPYARD]: {
        type: BuildingType.SHIPYARD,
        name: "Shipyard",
        description: "Build naval vessels for trade and warfare.",
        maxLevel: 20,
        prerequisite: { building: { type: BuildingType.TOWN_HALL, level: 5 } },
    },
    [BuildingType.WAREHOUSE]: {
        type: BuildingType.WAREHOUSE,
        name: "Warehouse",
        description: "Increases the storage capacity for your resources.",
        maxLevel: 25,
    },
    [BuildingType.TAVERN]: {
        type: BuildingType.TAVERN,
        name: "Tavern",
        description: "Serves wine to your citizens, increasing happiness.",
        maxLevel: 20,
        prerequisite: { building: { type: BuildingType.TOWN_HALL, level: 2 } },
    },
    [BuildingType.TRADING_POST]: {
        type: BuildingType.TRADING_POST,
        name: "Trading Post",
        description: "Enables trading resources with other cities.",
        maxLevel: 15,
        prerequisite: { building: { type: BuildingType.TOWN_HALL, level: 3 } },
    },
    [BuildingType.HARBOR]: {
        type: BuildingType.HARBOR,
        name: "Harbor",
        description: "Increases trade ship capacity and reduces travel time.",
        maxLevel: 20,
        prerequisite: { building: { type: BuildingType.TOWN_HALL, level: 3 } },
    },
    [BuildingType.WALL]: {
        type: BuildingType.WALL,
        name: "Town Wall",
        description: "Provides a defensive bonus to your garrison during attacks.",
        maxLevel: 20,
        prerequisite: { building: { type: BuildingType.TOWN_HALL, level: 4 } },
    },
    [BuildingType.HIDEOUT]: {
        type: BuildingType.HIDEOUT,
        name: "Hideout",
        description: "Protects a portion of your resources from being plundered.",
        maxLevel: 15,
        prerequisite: { building: { type: BuildingType.TOWN_HALL, level: 5 } },
    },
};
/**
 * Calculate building cost at a given level.
 * Formula: baseCost * 1.5^(level - 1)
 */
export function getBuildingCost(type, level) {
    const base = BUILDING_BASE_COSTS[type];
    const multiplier = Math.pow(1.5, level - 1);
    return {
        wood: Math.floor(base.wood * multiplier),
        marble: Math.floor((base.marble ?? 0) * multiplier),
        crystal: Math.floor((base.crystal ?? 0) * multiplier),
        sulfur: Math.floor((base.sulfur ?? 0) * multiplier),
    };
}
/**
 * Calculate building time at a given level (in seconds).
 * Formula: baseTime * 1.4^(level - 1)
 */
export function getBuildingTime(type, level) {
    const baseTime = BUILDING_BASE_TIMES[type];
    return Math.floor(baseTime * Math.pow(1.4, level - 1));
}
// Base costs for level 1 of each building
const BUILDING_BASE_COSTS = {
    [BuildingType.TOWN_HALL]: { wood: 200, marble: 100 },
    [BuildingType.ACADEMY]: { wood: 400, marble: 200, crystal: 100 },
    [BuildingType.BARRACKS]: { wood: 300, marble: 150, sulfur: 50 },
    [BuildingType.SHIPYARD]: { wood: 500, marble: 250, sulfur: 100 },
    [BuildingType.WAREHOUSE]: { wood: 150, marble: 80 },
    [BuildingType.TAVERN]: { wood: 250, marble: 120 },
    [BuildingType.TRADING_POST]: { wood: 350, marble: 180 },
    [BuildingType.HARBOR]: { wood: 400, marble: 200 },
    [BuildingType.WALL]: { wood: 300, marble: 250 },
    [BuildingType.HIDEOUT]: { wood: 200, marble: 100 },
};
// Base build times in seconds for level 1
const BUILDING_BASE_TIMES = {
    [BuildingType.TOWN_HALL]: 600, // 10 min
    [BuildingType.ACADEMY]: 900, // 15 min
    [BuildingType.BARRACKS]: 720, // 12 min
    [BuildingType.SHIPYARD]: 1200, // 20 min
    [BuildingType.WAREHOUSE]: 480, // 8 min
    [BuildingType.TAVERN]: 540, // 9 min
    [BuildingType.TRADING_POST]: 660, // 11 min
    [BuildingType.HARBOR]: 780, // 13 min
    [BuildingType.WALL]: 600, // 10 min
    [BuildingType.HIDEOUT]: 420, // 7 min
};
//# sourceMappingURL=buildings.js.map